import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";

class O {
  id!: number;
}

/**
 * O Inner Class
 */
class I {
  id?: number;
  name!: string;
  enabled: boolean = true;
}


/**
 * PutDashboardCB class
 */
export class PutDashboardCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.PutDashboard);
    this.i = new I();
    this.o = new O();
  }

}
